import { render, staticRenderFns } from "./lock-position-selector-modal.vue?vue&type=template&id=f63b0560&"
import script from "./lock-position-selector-modal.vue?vue&type=script&lang=js&"
export * from "./lock-position-selector-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports